/* eslint-disable @typescript-eslint/ban-ts-comment */
import NotamContent from './notam-content';
import {INotamAI} from '@/firebase/airport';
import {uppercaseFirstLetter} from '@/utils/string';
import classNames from 'classnames';
import moment from 'moment';
import {memo, useState} from 'react';

interface Props {
  item: INotamAI;
  hasBorder: boolean;
  airport?: string;
  index: number;
}

const NotamAIItemComponent: React.FC<Props> = ({
  item,
  airport = '',
  hasBorder,
  index
}) => {
  const [showMore, setShowMore] = useState(false);
  const [showOrigin, setShowOrigin] = useState(false);
  const getAirport = () => {
    if (airport) {
      return airport;
    }
    if (item?.airport) {
      return item?.airport;
    }
    if (item?.fir) {
      return item?.fir;
    }
    return '';
  };

  return (
    <div
      className={classNames('bg-[#011F2480] pt-[16px] w-full pb-[4px]', {
        'border-b border-[#3030304D]': hasBorder
      })}
    >
      <div className="flex items-center justify-between w-full mb-[8px] px-[16px]">
        {item.isEffective ? (
          <div className="bg-[#4C1D95] rounded-[4px] py-[6px] px-[8px]">
            <p className="text-[14px] font-Geist-Mono leading-[14px] text-[#C4B5FD] tracking-[-0.28px] font-medium">
              APPLICABLE
            </p>
          </div>
        ) : (
          <div className="bg-[#44403C] rounded-[4px] py-[6px] px-[8px]">
            <p className="text-[14px] font-Geist-Mono leading-[14px] text-[#78716C] tracking-[-0.28px] font-medium">
              NOT APPLICABLE
            </p>
          </div>
        )}
      </div>
      <div className="h-[36px] flex items-center">
        <div className="w-full flex justify-between px-[16px]">
          <div className="flex items-center">
            <div className="items-center justify-center rounded-[16px] bg-[#0C4A6E] py-[4px] px-[8px]">
              {(item?.type || item?.category) && (
                <p className="font-Geist text-[14px] leading-[14px] text-[#E7E5E4] font-medium">
                  {uppercaseFirstLetter(item?.type ?? item?.category)}
                </p>
              )}
            </div>
            <p className="font-Geist-Mono text-[#A8A29E] text-[14px] leading-[14px] ml-[8px] tracking-[-0.28px]">
              {item?.end_date === 'PERM' ? 'PERMANENT' : `ENDS:`}
            </p>
            {item?.end_date !== 'PERM' && (
              <p className="ml-[4px] font-Geist-Mono text-[#A8A29E] text-[14px] leading-[14px] tracking-[-0.28px]">
                {moment(item?.end_date, 'DD/MM/YYYY HH:mm').format(
                  'DD/MM/YY HH:mm'
                )}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="px-[8px] mt-[8px]">
        <NotamContent
          showMore={showMore}
          item={item}
          setShowMore={setShowMore}
        />
      </div>

      <div className="w-full px-[16px] py-[8px] flex items-center justify-between h-[36px]">
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center">
            <div className="flex items-center font-Geist-Mono text-[14px] leading-[14px] tracking-[-0.28px] text-[#78716C]">
              {getAirport()}•{item?.notamID}•
              <p className="font-Geist text-[14px] leading-[14px] tracking-[-0.28px] text-[#78716C]">
                {item?.created
                  ? moment(item?.created, 'DD/MM/YYYY HH:mm').fromNow()
                  : ''}
              </p>
            </div>
            <div
              className="cursor-pointer hover:opacity-80"
              onClick={() => setShowOrigin(!showOrigin)}
            >
              <p className="text-[#38BDF8] font-Geist ml-[6px] text-[14px] leading-[14px] tracking-[-0.28px] font-medium">
                {showOrigin ? 'Hide Original' : 'Show Original'}
              </p>
            </div>
          </div>
        </div>
      </div>
      {showOrigin ? (
        <div className="w-full px-[8px] mb-[8px]">
          <div className="bg-[#072F39] p-[12px] rounded-[8px] mt-[8px]">
            <p className="font-Geist-Mono text-[#A8A29E] text-[16px] leading-[22px] tracking-[-0.28px] break-all">
              {item?.raw}
            </p>
          </div>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};

const NotamAIItem = memo(NotamAIItemComponent);
export default NotamAIItem;
